/* eslint-disable */
import React from 'react'
import { Tabs } from 'antd'
import { withQuery } from '@/utils'
import styles from './finances.module.scss'
import FinancesSummary from './summary'
import Transactions from './Transactions'
import FundFlowList from './FundFlowList'

function Section({ title, children }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  )
}

function Finances() {
  return (
    <div className={styles.container}>
      <Section title="财务总览">
        <FinancesSummary />
      </Section>
      <div style={{paddingTop: 10}}>
        <Tabs
          defaultActiveKey={'1'}
          className={styles.tabs}
          type="card">
          <Tabs.TabPane key="1" tab="交易记录">
            <Transactions />
          </Tabs.TabPane>
          {/* <Tabs.TabPane key="2" tab="收支明细">
            <FundFlowList />
          </Tabs.TabPane> */}
        </Tabs>
      </div>
    </div>
  )
}

export default withQuery(Finances)
